import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppSettingsNavComponent } from './components/app-settings-nav/app-settings-nav.component';
import { AppSettingsGeneralInfoFormComponent } from './components/app-settings-general-info-form/app-settings-general-info-form.component';
import { AppSettingsEmailConfigFormComponent } from './components/app-settings-email-config-form/app-settings-email-config-form.component';
import { AppSettingsCourseManageFormComponent } from './components/app-settings-course-manage-form/app-settings-course-manage-form.component';
import { AppSettingsSecurityFormComponent } from './components/app-settings-security-form/app-settings-security-form.component';
import { AppSettingsMaintenanceFormComponent } from './components/app-settings-maintenance-form/app-settings-maintenance-form.component';

@Component({
  selector: 'app-admin-settings',
  standalone: true,
  imports: [
    CommonModule, 
    FormsModule, 
    ReactiveFormsModule, 
    AppSettingsNavComponent,
    AppSettingsGeneralInfoFormComponent,
    AppSettingsEmailConfigFormComponent,
    AppSettingsCourseManageFormComponent,
    AppSettingsSecurityFormComponent,
    AppSettingsMaintenanceFormComponent
  ],
  templateUrl: './admin-settings.component.html',
  styleUrl: './admin-settings.component.css'
})
export class AdminSettingsComponent {

  // Panel management
  activePanel: string = 'general';
  isLoading: boolean = false;

  constructor() {
    // Initialize with general settings panel
  }

  /**
   * Set the active settings panel
   */
  setActivePanel(panel: string): void {
    this.activePanel = panel;
  }

  /**
   * Refresh settings data
   */
  refreshSettings(): void {
    this.isLoading = true;
    
    // Simulate API call to refresh settings
    setTimeout(() => {
      this.isLoading = false;
      console.log('Settings refreshed');
    }, 1000);
  }

  // Event handlers for child components
  onPanelChange(panel: string): void {
    this.activePanel = panel;
  }
}
